// extracted by mini-css-extract-plugin
export default {"additionalSettingsSection":"PropertyDefinitionForm-module__additionalSettingsSection--_SRpa","propertyFormControl":"PropertyDefinitionForm-module__propertyFormControl--Tc2cE"};